export default __webpack_public_path__ + "static/media/object--manhole.049795d8.png";